const LOCAL_STORAGE_PREFIX: string = 'shipitweb-';

export { LOCAL_STORAGE_PREFIX };
